module.exports = __webpack_public_path__ + "img/darker_warning.2c14f01d.svg";